import api from '../../api'

import {
    GET_USERS,
    EDIT_USERS
} from '../types'
import {firebase} from '../../../firebase/initFirebase'
import axios from'axios'
import { message} from 'antd';
import moment from 'moment'

export const GetUsers = (props) => {
    return async dispatch => {    
        var Firestore = firebase.firestore();
        var UserRef = Firestore.collection("users")
                        .orderBy("role","desc")
                  
        UserRef = UserRef.limit(1000)     

      
        UserRef.get()
        .then((documentSnapshots) => {      
            var docs = documentSnapshots.docs
         
            var orderArray =[]
            docs.map(item=>{
                var newOrder={...item.data()}
                orderArray.push(newOrder)
             
            })
            console.log(orderArray)
          
           
            dispatch({ type: GET_USERS, payload: orderArray })  
            
            
         
        })
        .catch(err=>{
            console.log(err)
        })

    }
}


export const EditUser = (order) => {
    return async dispatch => {      
        var Firestore = firebase.firestore();
        var UserRef = Firestore.collection("users")
    
        UserRef.doc(order.order_id).set({ ...order})
        .then((doc) => {   
            message.success("order edit success")         
            dispatch({ type: EDIT_USERS, payload: order })    
        }).catch((error) => {
            console.error('error',error);
            message.error('order edit error')
        }); 
    }
}











